import _ from 'lodash'

export default class PlanboardMode {
  constructor(planboard) {
    this.planboard = planboard
    this.waitingSlot = null
  }

  start() {}

  stop() {}

  showPlanner() {
    if (this.planner) {
      this.planner.show()
    }
  }

  hidePlanner() {
    if (this.planner) {
      this.planner.hide()
    }
  }

  book() {
    if (this.planner) {
      this.planner.book()
    }
  }

  update() {
    if (this.planner) {
      this.planner.update()
    }
  }

  clearWaitingSlot() {
    if (this.waitingSlot) {
      this.waitingSlot = null
    }
  }

  slotClick($slot, evt) {
    console.log('slotClick', arguments, this.waitingSlot)

    // If there is a slot waiting
    if (this.waitingSlot) {
      var waitingSlotResult = this.waitingSlot($slot)
      this.update()
      if (waitingSlotResult) {
        this.waitingSlot = null // No slot waiting anymore
      }
    }

    evt.preventDefault()
    evt.stopPropagation()
    evt.stopImmediatePropagation()
  }

  modal(html) {
    $('#briq-modal')
      .modal('show')
      .find('.modal__body')
      .html(html)
      .trigger('bless')
  }

  reset() {
    this.planboard.$defaultButtons.show()
    this.planboard.$blockSlotsButtons.hide()
    this.planboard.$newBookingButtons.hide()
    this.planboard.$elm.find('.planboard-slot').removeClass('active selected-block selected')
    this.planboard.$packageSelector.removeClass('active')
    this.planboard.$activityRows.removeClass('planboard__activity--dimmed')
  }

  setProductGroupTitle() {
    var self = this
    $('.planboard__package-selector.active')
      .find('.box__title-context')
      .text(function(e, str) {
        if (self.planboard.productGroups.length) {
          return (
            '(' +
            self.planboard.productGroups.map(productGroup => productGroup.name).join(' + ') +
            ')'
          )
        }
        return ''
      })
  }

  changeTimeslot($el) {
    var self = this
    if (this.waitingSlot === null) {
      // Must be free to select a slot
      var $elParent = $el
          .parents('[data-selected-slot]')
          .addClass('planboard-package-product--waiting'),
        activityKey = $elParent.attr('data-activity-key'),
        activityType = $elParent.attr('data-activity-type')
      const instance = self.planboard.$activityRows.removeClass('planboard__activity--dimmed')
      if (activityKey) {
        const notSelector =
          activityType === 'ResourceGroup' ? 'data-activity-parent-key' : 'data-activity-key'
        instance.not(`[${notSelector}="${activityKey}"]`).addClass('planboard__activity--dimmed')
      }

      $el
        .parents('.planboard__package-selector')
        .find('[data-planboard-action="addtimeslot"], [data-toggle="modal"]')
        .prop('disabled', true)
      $elParent
        .siblings()
        .addBack()
        .find('[data-planboard-action]')
        .prop('disabled', true)

      // When a slot is already assigned, clean up and reset texts
      if ($elParent.attr('data-selected-slot')) {
        self.planboard.$elm
          .find('.planboard-slot[data-id="' + $elParent.attr('data-selected-slot') + '"]')
          .addClass('changing')
        if (!$elParent.attr('data-activity-key')) {
          $elParent.find('.table__cell--activity').text('Please make a selection')
        }

        self.planboard.syncSelectorWithPlanboard()
      }

      self.planboard.checkIfPackageBookable()

      // Function to be called when user has clicked a slot in the timeline
      this.waitingSlot = function($slot) {
        if ($slot.attr('data-available') == 'false') {
          return false // Prevent selection of occupied slots
        }

        self.planboard.dirty = true
        var newlyAddedSlot = !$elParent.attr('data-activity-key') // Check if this is a newly added slot
        var isActivityKeyMatch =
          $slot.attr('data-activity-key') == $elParent.attr('data-activity-key')
        var isActivityParentKeyMatch =
          $slot.attr('data-activity-parent-key') == $elParent.attr('data-activity-key')

        if (
          newlyAddedSlot ||
          ((isActivityKeyMatch || isActivityParentKeyMatch) &&
            !$slot.parents('.planboard__activity--dimmed').length)
        ) {
          // check of product group key, zo ja voeg $productkey, $productgroupkey, $dealid toe
          if ($elParent.attr('data-product-group-key')) {
            $elParent.find('input[type=hidden]').val(
              JSON.stringify({
                id: $slot.data('id'),
                productKey: $elParent.attr('data-product-key'),
                productGroupKey: $elParent.attr('data-product-group-key'),
                productGroupName: $elParent.attr('data-product-group-name'),
                productGroupProductKey: $elParent.attr('data-product-group-product-key'),
                productGroupProductQuantity: $elParent.attr('data-product-group-product-quantity'),
                dealId: $elParent.attr('data-deal'),
              }),
            )
          } else {
            $elParent.find('input[type=hidden]').val($slot.data('id'))
          }

          $elParent
            .attr('data-selected-slot', $slot.attr('data-id'))
            .removeClass('planboard-package-product--waiting')
            .find('.table__cell--slot-time')
            .text($slot.attr('data-start-time'))
            .end()
            .find('[data-planboard-action="changetimeslot"]')
            .text('Change timeslot')

          $el
            .parents('.planboard__package-selector')
            .find('[data-planboard-action="addtimeslot"], [data-toggle="modal"]')
            .prop('disabled', false)

          $elParent
            .siblings()
            .addBack()
            .find('[data-planboard-action]')
            .prop('disabled', false)

          if (newlyAddedSlot) {
            var $activityRow = $slot.parents('.planboard__activity'),
              activityLabel = _.template(window.templates.packageTableRowActivityLabel)({
                name: $activityRow.attr('data-activity-name'),
                color: $activityRow.attr('data-activity-color'),
                initials: $activityRow.attr('data-activity-initials'),
                activity: $slot.attr('data-activity-key'),
                iteration: $elParent.index(),
                selectedSlot: $slot.attr('data-id'),
              })

            $elParent
              .attr('data-id', $elParent.index() + '-' + $slot.attr('data-activity-key')) // Manually set data-id in the case of a newly added slot
              .find('.table__cell--activity')
              .html(activityLabel)
          }

          self.planboard.$elm.find('.planboard-slot.changing').removeClass('changing')
          self.planboard.syncSelectorWithPlanboard()
          self.planboard.checkIfPackageBookable()

          self.planboard.$activityRows.removeClass('planboard__activity--dimmed')

          return true
        }

        return false
      }
    }
  }
}
